<template>
  <div class="invite-by-gmail-container">
    <label v-html="$t('let.invite.gmail')"></label>
    <gmail-button :label="$t('invite.gmail.contacts')" @click="shareToGmail" id="gmail-btn"></gmail-button>
    <share-to-gmail-contact
      :visible="visible"
      :data="data"
      :confirm-loading="confirmLoading"
      @cancel="handleCancel"
      @confirm="handleConfirm"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import GmailButton from '@/components/common/social/GmailButton.vue';
import { SEND_INVITATION_EMAIL } from '@/store/referrals/actionTypes';
import { SHOW_DEFAULT_ERROR_NOTIFICATION } from '@/store/notification/actionTypes';
import ShareToGmailContact from './ShareToGmailContact.vue';

const CONTACT_INFO_MASK = 'emailAddresses,names';

export default {
  data() {
    return {
      data: [],
      visible: false,
      confirmLoading: false,
    };
  },
  components: {
    GmailButton,
    ShareToGmailContact,
  },
  methods: {
    ...mapActions({
      sendInvitationMail: SEND_INVITATION_EMAIL,
      showErrorNotification: SHOW_DEFAULT_ERROR_NOTIFICATION,
    }),
    initApi() {
      return new Promise((resolve) => {
        window.gapi.load('client', resolve);
      }).then(() =>
        window.gapi.client.init({
          apiKey: 'AIzaSyAubvrkCGW__4AFLj9XXAdfltUasuFS9aY',
          discoveryDocs: ['https://people.googleapis.com/$discovery/rest'],
          clientId:
            '431395576260-581v3831vr3mk88mdm45bhieen8pf6mk.apps.googleusercontent.com',
          scope: 'https://www.googleapis.com/auth/contacts.other.readonly',
        }),
      );
    },
    loadOtherContacts() {
      return window.gapi.client.people.otherContacts
        .list({
          readMask: CONTACT_INFO_MASK,
        })
        .then((response) => response.result.otherContacts)
        .then((contacts) =>
          contacts.reduce((results, contact) => {
            return results.concat(
              contact.emailAddresses.map((address) => ({
                email: address.value,
                name: this.getContactName(contact),
              })),
            );
          }, []),
        )
        .then((data) => {
          this.data = data;
        });
    },
    signIn() {
      return window.gapi.auth2.getAuthInstance().signIn();
    },
    async shareToGmail() {
      if (!this.data.length) {
        await this.initApi();
        await this.signIn();
        await this.loadOtherContacts();
      }

      this.showContactsModal();
    },
    showContactsModal() {
      this.visible = true;
    },
    getContactName(contact) {
      return contact.names?.length ? contact.names[0].displayName : '';
    },
    handleCancel() {
      this.visible = false;
    },
    async handleConfirm(selectedContact) {
      this.confirmLoading = true;

      try {
        const emails = selectedContact.map((contact) => contact.email);
        await this.sendInvitationMail(emails);
        this.visible = false;
      } catch {
        this.showErrorNotification();
      } finally {
        this.confirmLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/metrics.scss';

.invite-by-gmail-container {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .ant-btn {
    margin: 0;
    padding: 0;
  }
}

label {
  margin-bottom: $tiny;
  flex: 1;
}

#gmail-btn {
  flex: 1;
  min-width: 60px;
}
</style>
